export default "__VITE_ASSET__BYS3KiiB__"